import { render, staticRenderFns } from "./AlterarPromocao.vue?vue&type=template&id=1d3a4932"
import script from "./AlterarPromocao.vue?vue&type=script&lang=ts"
export * from "./AlterarPromocao.vue?vue&type=script&lang=ts"
import style0 from "./AlterarPromocao.vue?vue&type=style&index=0&id=1d3a4932&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports